$(document).ready(function () {
    // filling country dropdown list with all the countries
    function saveCountry(item) {
        $('[name="COUNTRY"]').append(`<option value="${item.threeLetterIsoCode}"> ${item.name} </option>`);
    }

    function getCountryCode(country) {
        for (var i = 0; i < CountryList().get().length; i++) {// eslint-disable-line no-undef, new-cap
            if (CountryList().get()[i].name.toLowerCase() === country.toLowerCase()) {// eslint-disable-line no-undef, new-cap
                return CountryList().get()[i].threeLetterIsoCode;// eslint-disable-line no-undef, new-cap
            }
        }
    }

    function checkEmptyValues() {
        if ($('[name="NAME"]').val() === '' ||
            $('[name="COMPANY_NAME"]').val() === '' ||
            $('[name="FIRST_NAME"]').val() === '' ||
            $('[name="EMAIL"]').val() === '' ||
            $('[name="POSTAL_CODE"]').val() === '' ||
            $('[name="COUNTRY"]').val() === '' ||
            $('[name="MESSAGE"]').val() === '') {
            return false;
        }
        return true;
    }

    CountryList().get().forEach(saveCountry);// eslint-disable-line no-undef, new-cap
    let queryString = new QueryStringProcessor().getUrlParams();// eslint-disable-line no-undef
    if (queryString.country) {
        var countryCode = getCountryCode(queryString.country);
        $('[name="COUNTRY"] option[value="' + countryCode + '"]').attr('selected', true);
    }
    // END filling country dropdown list with all the countries

    // adding
    //  - reCaptcha validation
    //  - Pardot FORM request to SF
    // to submit button click event (it is executed before submit event)
    $('#mi-OEM-contact-form').on('click', function (event) {
        var selectedContactType = $('[name="RELATION_TYPE"] option:selected').val();
        var recaptchaBox = $(this).parentsUntil('#mi-corpo-OEM-contact-form-submit').parent();
        if (recaptchaBox.find('input[name=\'completed_captcha\']').val() !== 'valid') {
            recaptchaBox.find('#mi-corpo-contact-form-download-invalid-recaptcha').show();
            event.preventDefault();
            event.stopPropagation();
            return false;
        }
        else {
            if (selectedContactType !== '- Select -' && checkEmptyValues()) {
                $.post('/register-OEM-form-action',
                    {
                        NAME: $('[name="NAME"]').val(),
                        COMPANY_NAME: $('[name="COMPANY_NAME"]').val(),
                        FIRST_NAME: $('[name="FIRST_NAME"]').val(),
                        EMAIL: $('[name="EMAIL"]').val(),
                        RELATION_TYPE: $('[name="RELATION_TYPE"]').val(),
                        POSTAL_CODE: $('[name="POSTAL_CODE"]').val(),
                        COUNTRY: $('[name="COUNTRY"]').val(),
                        PRODUCT: window.location.pathname.split('/').pop(),
                        MESSAGE: $('[name="MESSAGE"]').val(),
                        SITE_NAME: document.querySelector('meta[property=\'og:site_name\']').getAttribute('content')
                    });
            }
        }

        recaptchaBox.find('#mi-corpo-contact-form-download-invalid-recaptcha').hide();
    });

    $('input[type="text"], textarea').on('blur change', function (e) {
        var $this = $(this); var val = $this.val(); if (val.trim() === val) {
            e.preventDefault(); return false;
        }
        else {
            $this.val(val.trim()); $this.change();
        }
    });
});
